'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* 处理快照结构化数据*/


var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _getSettingFromConfig = require('./getSettingFromConfig');

var _getSettingFromConfig2 = _interopRequireDefault(_getSettingFromConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* const getTop3SubjectId = subjectId => {
  const ids = [];
  let i = 3;
  while (i <= subjectId.length) {
    ids.push(subjectId.substring(0, i));
    i += 2;
  }
  return ids;
};*/
var format = function format() {
  var briefData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = arguments[1];
  var partners = _ref.partners,
      otherFtMap = _ref.otherFtMap;

  if (_lodash2.default.isEmpty(briefData)) {
    return;
  }
  var _briefData$stSnapInfo = briefData.stSnapInfo;
  _briefData$stSnapInfo = _briefData$stSnapInfo === undefined ? {} : _briefData$stSnapInfo;
  var pkId = _briefData$stSnapInfo.sPKId,
      _briefData$stSnapInfo2 = _briefData$stSnapInfo.mpSnapScores,
      mpSnapScores = _briefData$stSnapInfo2 === undefined ? {} : _briefData$stSnapInfo2,
      _briefData$stSnapInfo3 = _briefData$stSnapInfo.version2Attentions;
  _briefData$stSnapInfo3 = _briefData$stSnapInfo3 === undefined ? {} : _briefData$stSnapInfo3;
  var tagDefaultInfo = _briefData$stSnapInfo3.default,
      _briefData$stSnapInfo4 = _briefData$stSnapInfo.mapExpand,
      mapExpand = _briefData$stSnapInfo4 === undefined ? [] : _briefData$stSnapInfo4;
  // const { subjectId } = briefData;

  var isRumor = !!mapExpand['248'];
  var puin = mapExpand['255'] || '';
  var political = !!mapExpand['334']; // 政治敏感词
  var adExtInfo = mapExpand['354'] || ''; // 广告商业化统一透传字段
  var isSafety = mapExpand['370'] || ''; // 安全标示 为1则为内容安全展示
  /* const { item: channels, ch = '007701' } = channelMap;
  if (iArea) {
    subjectId = '000';
  }
  let guideTab;
   if (isRumor && Array.isArray(channels)) { // 辟谣逻辑
    guideTab = channels.find(item => item.key === 'piyao');
  } else if (Array.isArray(channels) && subjectId) {
    const top3Ids = getTop3SubjectId(subjectId) || []; // 获取前三级主题
    while (top3Ids.length && _.isEmpty(guideTab)) {
      const id = top3Ids.pop();
      guideTab = channels.find(item => item.key === id);  //  优先从三级主题匹配
    }
  }
  if (!_.isEmpty(guideTab)) {
    const { tab } = guideTab;
    guideTab.url = `qb://home/feeds?tabId=${tab}&ch=${ch}&refresh=1`;
  } */
  var configInfo = (0, _getSettingFromConfig2.default)(briefData, partners, otherFtMap);
  var data = _extends({}, briefData, {
    pkId: pkId,
    isRumor: isRumor
  }, configInfo, {
    isSafety: isSafety,
    iHighQuality: mpSnapScores['35'] || '',
    tagDefaultInfo: tagDefaultInfo,
    puin: puin,
    political: political,
    adExtInfo: adExtInfo
  });
  /*
  const tags = data.tags || [];
  data = _.omit(data, 'stSnapInfo', 'tags');
  data.tags = (tags instanceof Array && tags.length > 2) ? tags.splice(0, 2) : tags.splice(0, tags.length);
  */
  return data;
};
exports.default = format;